/* eslint-disable no-nested-ternary */
import React from 'react';
import { useSelector } from 'react-redux';
import { Button, ButtonGroup, Content, Dialog, Divider, Flex, Heading, useDialogContainer, } from '@adobe/react-spectrum';
import { PublishActions } from 'app/stores/publish/actions';
import { getSelectedPlatform, isPublishingToPlatform, } from 'app/stores/publish/selectors';
import { useAppDispatch } from 'app/stores/store';
import { Placeholder } from 'app/views/components/dialogs/publish/Placeholder';
import { getPlatformDetails, getPlatformTag, isPlatformEnabled, PlatformType, } from 'app/views/components/dialogs/publish/platform';
import { PlatformPicker } from 'app/views/components/dialogs/publish/PlatformPicker';
import { analytics } from 'app/utils/analytics';
import { PublishWell as AnnotelyPublishWell } from './annotely/PublishWell';
import { PublishWell as AdobePublishWell } from './platforms/adobe/PublishWell';
import { PublishWell as BoxPublishWell } from './platforms/box/PublishWell';
import { PublishWell as DropboxPublishWell } from './platforms/dropbox/PublishWell';
import { PublishWell as GooglePublishWell } from './platforms/google/PublishWell';
import { PublishWell as OneDrivePublishWell } from './platforms/onedrive/PublishWell';
const PublishWell = (props) => {
    const { platform } = props;
    switch (platform) {
        case PlatformType.Annotely:
            return React.createElement(AnnotelyPublishWell, null);
        case PlatformType.AdobeCloud:
            return React.createElement(AdobePublishWell, null);
        case PlatformType.Dropbox:
            return React.createElement(DropboxPublishWell, null);
        case PlatformType.Box:
            return React.createElement(BoxPublishWell, null);
        case PlatformType.GoogleDrive:
            return React.createElement(GooglePublishWell, null);
        case PlatformType.OneDrive:
            return React.createElement(OneDrivePublishWell, null);
        case PlatformType.AmazonS3:
            return null;
        default:
            return null;
    }
};
export const PublishDialog = () => {
    const dispatch = useAppDispatch();
    const dialog = useDialogContainer();
    const currentPlatformType = useSelector((state) => getSelectedPlatform(state));
    const publishingToPlatform = useSelector((state) => isPublishingToPlatform(state, currentPlatformType));
    const onPublish = React.useCallback(() => {
        if (publishingToPlatform) {
            return;
        }
        analytics({
            action: 'PublishPlaform:Publish',
            label: getPlatformTag(currentPlatformType),
        });
        dispatch(PublishActions.publishToPlatform({
            platform: currentPlatformType,
            format: 'image/jpeg',
        }));
    }, [currentPlatformType, publishingToPlatform, dispatch]);
    const platform = getPlatformDetails(currentPlatformType);
    const platformIsEnabled = isPlatformEnabled(currentPlatformType);
    return (React.createElement(Dialog, { "data-test-id": "publish-dialog" },
        React.createElement(Heading, null, "Publish and share image"),
        React.createElement(Divider, { size: "S" }),
        React.createElement(Content, null,
            React.createElement(Flex, { direction: "column" },
                React.createElement(PlatformPicker, null),
                platformIsEnabled ? (React.createElement(PublishWell, { platform: currentPlatformType })) : (React.createElement(Placeholder, { platform: platform })))),
        React.createElement(ButtonGroup, null,
            React.createElement(Button, { "data-test-id": "cancel", variant: "secondary", onPress: dialog.dismiss }, "Cancel"),
            React.createElement(Button, { "data-test-id": "publish", variant: "cta", isDisabled: !platformIsEnabled || publishingToPlatform, onPress: onPublish }, "Publish"))));
};
